const AGE_BAND_DISPLAY_OVERRIDES: Record<string, string> = {
  "120-180": "121-180",
};

export function displayAgeBandLabel(label: string): string {
  return AGE_BAND_DISPLAY_OVERRIDES[label] ?? label;
}
